"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var template_checkbox_tree_module_scss_1 = __importDefault(require("./template-checkbox-tree.module.scss"));

var use_checked_values_hook_1 = __importDefault(require("./use-checked-values.hook"));

var react_checkbox_tree_1 = __importDefault(require("react-checkbox-tree"));

var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));

var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));

var custom_checkbox_icon_component_1 = __importDefault(require("../../common-components/custom-checkbox-icon/custom-checkbox-icon.component"));

var icons = {
  check: react_1.default.createElement(custom_checkbox_icon_component_1.default, {
    checked: true
  }),
  uncheck: react_1.default.createElement(custom_checkbox_icon_component_1.default, {
    checked: false
  }),
  halfCheck: react_1.default.createElement(custom_checkbox_icon_component_1.default, {
    checked: true
  }),
  expandClose: react_1.default.createElement(ChevronRight_1.default, {
    fontSize: "large"
  }),
  expandOpen: react_1.default.createElement(ExpandMore_1.default, {
    fontSize: "large"
  })
};

var TemplateCheckboxTree = function TemplateCheckboxTree(_ref) {
  var checkBoxNodes = _ref.checkBoxNodes,
      onCheckedChange = _ref.onCheckedChange;

  var _use_checked_values_h = use_checked_values_hook_1.default(checkBoxNodes, onCheckedChange),
      checked = _use_checked_values_h.checked,
      handleChecked = _use_checked_values_h.handleChecked;

  var _react_1$useState = react_1.useState([]),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      expanded = _react_1$useState2[0],
      setExpanded = _react_1$useState2[1];

  return react_1.default.createElement("div", {
    className: template_checkbox_tree_module_scss_1.default.checkBoxTreeWrapper
  }, react_1.default.createElement(react_checkbox_tree_1.default, {
    nodes: checkBoxNodes,
    checked: checked,
    expanded: expanded,
    // react-checkbox-tree の type definition に targetNode を追加すること
    onCheck: handleChecked,
    onExpand: function onExpand(expanded) {
      return setExpanded(expanded);
    },
    icons: icons,
    expandOnClick: true,
    showNodeIcon: false,
    noCascade: true
  }));
};

exports.default = TemplateCheckboxTree;